<template>
  <p
    v-if="textBubbleContent"
    class="syncc-stories-feed__text-bubble-8N3klwN"
    :style="textBubbleStyle"
    v-on:click.prevent="conversionVideo"
  >
    {{ textBubbleContent }}
  </p>
</template>

<script>
export default {
  props: {
    textBubbleContent: { type: String, required: false },
    textBubbleStyle: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    conversionVideo() {
      this.$emit("conversion-video");
    },
  },
};
</script>